import {Observable} from 'rxjs';
import {map}        from 'rxjs/operators';

import IErrorsPayload from '../../../Player/Interfaces/IErrorsPayload';
import ErrorType      from '../../../Shared/Constants/ErrorType';
import LoadError      from '../Constants/LoadError';

/**
 * Maps errors originating from the `Html5Fairplay` load logic to
 * `IErrorsStreamPlayload` objects.
 */

const createLoadErrorsStream = (loadErrors$: Observable<Error>): Observable<IErrorsPayload> =>
    loadErrors$
        .pipe(
            map(source => {
                switch (source.message) {
                    case LoadError.WEBKIT_KEY_ERROR:
                    case LoadError.LICENSE_REQUEST_FAILED:
                    case LoadError.BAD_REQUEST:
                    case LoadError.FORBIDDEN:
                    case LoadError.INVALID_LICENSE:
                    case LoadError.NOT_AUTHORIZED:
                        return {
                            type: ErrorType.LICENSE_REQUEST_FAILED,
                            source
                        };
                    case LoadError.NETWORK_NO_SOURCE:
                        return {
                            type: ErrorType.MANIFEST_REQUEST_FAILED_DURING_LOAD,
                            source
                        };
                    case LoadError.CERTIFICATE_REQUEST_FAILED:
                        return {
                            type: ErrorType.CERTIFICATE_REQUEST_FAILED,
                            source
                        };
                    default:
                        return {
                            type: ErrorType.UNKNOWN_SOLUTION_ERROR,
                            source
                        };
                }
            })
        );

export default createLoadErrorsStream;